<template>
  <label
    class="c-toggle"
    :class="className"
    tabindex="0"
    @click.stop="() => {}"
    @keydown.space.prevent="keyToggle">
    <input
      type="checkbox"
      class="c-toggle__input"
      :checked="value"
      :disabled="disabled"
      :aria-label="ariaLabel"
      tabindex="-1"
      @change.stop="toggle" />
    <div class="c-toggle__core">
      <div class="c-toggle__button" />
    </div>
    <span
      class="c-toggle__label">
      <slot name="checked">
        <SvgIcon
          type="checkmark"
          small />
      </slot>
    </span>
  </label>
</template>

<script>
// This component is based on https://github.com/euvl/vue-js-toggle-button
// MIT license: https://github.com/euvl/vue-js-toggle-button/blob/master/LICENSE

export default {
  name: 'ToggleButton',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    ariaLabel: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      toggled: !!this.value,
    }
  },
  computed: {
    className() {
      return {
        '-toggled': this.toggled,
        '-disabled': this.disabled,
      }
    },
  },
  watch: {
    value(value) {
      this.toggled = !!value
    },
  },
  methods: {
    translate(x, y) {
      return `translate(${x}, ${y})`
    },
    keyToggle(event) {
      // the key event happens whether the control is disabled or not
      // nothing should be done if disabled is true
      if (this.disabled) {
        return
      }

      this.toggle(event)
    },

    toggle(event) {
      const toggled = !this.toggled

      this.$emit('input', toggled)
      this.$emit('change', {
        value: toggled,
        event,
      })
    },
  },
}
</script>
